import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconTimelapse } from '@travel-frontend/icons';
import { HeadlineSmall, Link, ParagraphMedium, Stack } from '../../primitives/index.js';
import { FLIGHT_DETAILS_QA_ID, qaId } from '../../utils/qaId.js';
export const Description = ({
  title,
  children,
  linkTitle,
  linkUrl
}) => _jsxs(Stack, {
  spacing: "medium",
  "data-testid": qaId(FLIGHT_DETAILS_QA_ID, 'description-stack'),
  children: [_jsxs(Stack, {
    direction: "row",
    spacing: "small",
    children: [_jsx(IconTimelapse, {}), _jsx(HeadlineSmall, {
      children: title
    })]
  }), _jsx(ParagraphMedium, {
    children: children
  }), linkTitle && linkUrl && _jsx(Link, {
    href: linkUrl,
    target: "_blank",
    children: linkTitle
  })]
});